import Image from "next/image";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { handlePlayPause } from "redux-share/actions/controller.actions";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const PlayPause = () => {

    useAppSelector(({ controller: { play, showMiniPlayer } }) => ({play, showMiniPlayer}), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <div
            className={`${!conditions(ConditionName.isTouchScreen) && "hover:pl-scale-125"} pl-transition-transform pl-ease-in-out pl-cursor-pointer`}
            onContextMenu={(event) => event.preventDefault()}
        >
            <Image
                src={conditions(ConditionName.isPlay) ? IMAGES.bigPause : IMAGES.bigPlay}
                width={conditions(ConditionName.isMiniPlayer) ? 48 : conditions(ConditionName.isTouchScreen) ? 56 : 72}
                height={conditions(ConditionName.isMiniPlayer) ? 48 : conditions(ConditionName.isTouchScreen) ? 56 : 72}
                onClick={handlePlayPause}
                onDoubleClick={(event: any) => event.stopPropagation()}
                className={`${conditions(ConditionName.isPlay) ? "pl-big-play-icon" : "pl-big-pause-icon"}`}
            />
        </div>
    )
}

export default PlayPause;